import { CreateScenarioDocument } from '@/generated/graphql';
import { useMyUser } from '@/user/composables/useMyUser';
import { useMutation } from '@vue/apollo-composable';
import { Ref, toValue } from 'vue';
import { ScenarioCreateSchemaType } from '../forms/schemas';

export function useScenarioCreate(scenarioGroupId: Ref<string>, data: Ref<ScenarioCreateSchemaType>) {
    const createScenarioMutation = useMutation(CreateScenarioDocument);
    const { currentUser } = useMyUser();

    async function create() {
        const response = await createScenarioMutation.mutate({
            scenarioGroupId: toValue(scenarioGroupId),
            ...toValue(data),
            createdById: toValue(currentUser).id,
            createdByName: toValue(currentUser).name,
        });
        if (response?.errors) {
            throw new Error(`Could not create Scenario: ${response.errors}`);
        }
        if (!response?.data?.createScenario?.scenario) {
            throw new Error('Create scenario did not return data');
        }
        return response.data.createScenario.scenario;
    }

    return {
        create,
    };
}
